/* unplugin-vue-components disabled */import { render } from "./SalePrice.vue?vue&type=template&id=27796f8a&scoped=true&ts=true"
import script from "./SalePrice.vue?vue&type=script&lang=ts"
export * from "./SalePrice.vue?vue&type=script&lang=ts"

import "./SalePrice.vue?vue&type=style&index=0&id=27796f8a&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27796f8a"]])

export default __exports__